<template>
  <div class="test-container">
    <h1>测试</h1>
    <div class="data-collection">
      <a-input v-model="orderId" placeholder="请输入订单ID" />
      <a-input v-model="appId" placeholder="请输入应用ID" />
      <a-input v-model="merchantNo" placeholder="请输入商户号" />
      <a-input v-model="secretKey" placeholder="请输入密钥" />
      <a-input v-model="gatewayURL" placeholder="请输入网关URL" />
      <h3 style="margin-top: 20px">订单信息</h3>
      <a-input v-model="amount" placeholder="请输入金额" />
      <a-input v-model="currency" placeholder="请输入币种" />
      <a-input v-model="country" placeholder="请输入国家" />
      <button class="order-btn" @click="init">创建订单</button>
    </div>
    <!-- <a-select
      style="width: 50%" 
      style="width: 50%"
      v-model="country"
      :size="'large'"
      show-search
      @change="handleChange"
      @search="handleSearch"
      :filter-option="false"
    >
      <template #label>请选择国家</template>
      <a-select-option
        v-for="countryItem in showData"
        :key="countryItem.name"z
        :value="countryItem.code"
        :label="countryItem.name"
        :title="countryItem.name"
      >
        {{ countryItem.name }}
      </a-select-option>
    </a-select> -->
    <template v-if="isCreateOrder">
      <h2 style="margin-top: 80px">订单详情</h2>
      <div style="display: flex; justify-content: center; height: 100%; width: 100%">
        <div class="checkout-wrapper">
          <div id="test"></div>
          <a-button id="payment" type="button">Payment</a-button>
          <div id="apple-pay" type="button" style="margin-top: 8px"></div>
          <div id="google-pay" type="button" style="margin-top: 8px"></div>
          <div class="item-error-tips" v-for="item in errorTips" :key="item">{{ item }}</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
// import countryList from '@/utils/tools/country'
import { postHttpCreateOrder } from '@/views/checkout/test/api/index'
import { loadScript } from '@/views/checkout/tools/utils'

export default {
  props: {},
  components: {},
  data() {
    return {
      // country: null,
      // allDataList: [...countryList],
      // otherCountryList: [], // 当前下拉框展示的数据（只展示前 N 条）
      // pageSize: 300, // 每页加载条数
      // currentPage: 1,
      orderId: new Date().getTime().toString(),
      appId: '1998997704361046018',
      merchantNo: '555752',
      secretKey: '000000',
      amount: '3.11',
      currency: 'USD',
      country: 'US',
      errorTips: [],
      gatewayURL: 'https://dev-securegtw.mzmcs.cc',
      isCreateOrder: false
    }
  },
  async created() {},
  mounted() {
    // this.showData = this.allDataList.slice(0, this.pageSize)
    // this.init()
  },
  // beforeDestroy() {
  //   // 添加事件监听
  //   window.removeEventListener('unload', this.onBeforeUnload);
  // },
  methods: {
    // handleChange(value) {
    //   this.country = value
    // }
    //  // 1. 处理滚动事件（模拟分页）
    // handlePopupScroll(e) {
    //   const { target } = e
    //   const { scrollTop, scrollHeight, clientHeight } = target
    //   // 判断是否滚动到底部
    //   if (scrollTop + clientHeight >= scrollHeight - 10) {
    //     // 如果还有更多数据，加载下一页
    //     if (this.otherCountryList.length < this.allDataList.length) {
    //       this.loadMoreData()
    //     }
    //   }
    // },
    // //2. 加载更多数据到展示列表
    // loadMoreData() {
    //   const start = this.currentPage * this.pageSize
    //   const end = start + this.pageSize
    //   const moreData = this.allDataList.slice(start, end)
    //   this.showData = [...this.otherCountryList, ...moreData]
    //   this.currentPage++
    // },
    //   // 3. 处理搜索（这里可以调用后端模糊查询，或者过滤全量数据）
    //   handleSearch(value) {
    //     this.currentPage = 1 // 重置页码
    //     if (!value) {
    //       // 搜索为空，展示默认前100条
    //       this.showData = this.allDataList.slice(0, this.pageSize)
    //       return null
    //     }
    //     try {
    //       this.showData = this.allDataList.filter((item) => item.name.toLowerCase().includes(value.toLowerCase()))
    //     } catch (e) {
    //       console.error(e)
    //     }
    //   }
    init() {
      const orderInfo = {
        // appId: '2052204895322370050',
        appId: this.appId,
        amount: this.amount,
        callbackUrl: 'https://develop.wondergate.io/webhook/test/notify',
        currency: this.currency,
        notificationUrl: 'https://develop.wondergate.io/webhook/test/notify',
        orderId: this.orderId,
        productInfos: [
          {
            quantity: 1,
            price: this.amount,
            productLink: 'http://test.org',
            sku: new Date().getTime().toString(),
            productName: 'Ergonomic Cotton Mouse'
          }
        ]
      }

      postHttpCreateOrder(this.gatewayURL + '/js/create', orderInfo, this.merchantNo, this.secretKey)
        .then((res) => {
          this.isCreateOrder = true
          console.log(res, 'res')
          this.createPayment(res)
        })
        .catch((err) => {
          console.error(err, 'error')
          // TODO: handle error
        })
    },
    // 创建支付
    createPayment(response) {
      const getAddressParams = () => ({
        billingAddress: {
          firstName: 'Pinkie',
          lastName: 'Olson',
          country: this.country,
          email: 'Emely.Wilderman@yahoo.com',
          city: 'Lake Kacie',
          address: '3986 Grimes Islands',
          phone: '+919876543210',
          zipCode: '36000'
        },
        shippingAddress: {
          firstName: 'Cecil',
          lastName: 'McDermott',
          country: this.country,
          email: 'Andreanne.Wintheiser37@hotmail.com',
          city: 'New Mylenemouth',
          address: '350 Bradtke Courts',
          phone: '+919876543210',
          state: 'AL',
          zipCode: '36000'
        }
      })

      loadScript(this.gatewayURL + '/script/js-sdk.min.umd.cjs').then(() => {
        const testPayment = JsPayment.createPayment({
          token: response.token,
          gateway: this.gatewayURL,
          cardOptions: {
            elementId: 'test',
            language: 'zh-cn',
            inputStyle: {
              color: 'red',
              fontSize: '15px'
            }
          },
          paymentMethodsOptions: {
            applePayOptions: {
              elementId: 'apple-pay',
              countryCode: this.country,
              label: '测试支付'
            },
            googlePayOptions: {
              elementId: 'google-pay',
              countryCode: this.country,
              label: 'Test Payment'
            }
          }
        })

        testPayment.onInitCompleted = (event) => {
          console.log(event, 'onInitCompleted')
        }

        testPayment.getPaymentInfo = getAddressParams

        testPayment.onPaymentCompleted = (event) => {
          console.log(event, 'onPaymentCompleted')
          this.$info({
            title: JSON.stringify(event)
          })
        }

        testPayment.onError = (event) => {
          console.log(event, 'onError')
          this.errorTips.push(event?.message)
        }

        document.getElementById('payment')?.addEventListener('click', () => {
          console.log(testPayment, 'click')
          testPayment.pay('CreditCard')
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/styles/common.less';

::v-deep(.ant-modal) {
  padding-bottom: 0 !important;
}

.test-container {
  width: 1200px;
  margin: 0 auto;
  padding-top: 80px;
  height: 100%;
  text-align: center;
}

.data-collection {
  display: flex;
  flex-direction: column;
  align-items: center;

  input,
  .order-btn {
    margin-top: 10px;
    width: 50%;
    height: 40px;
  }
}

.checkout-wrapper {
  width: 430px;
  height: 300px;
}

#payment {
  width: 100%;
  height: 40px;
}

#test {
  padding: 10px 0;
}

input {
  outline: 0;
  border: 0;
  background: transparent;
  color: #264373;
  width: 100%;
  height: 100%;
}

button {
  border-radius: 8px;
  border: 1px solid transparent;
  padding: 0.6em 1.2em;
  font-size: 1em;
  font-weight: 500;
  font-family: inherit;
  background-color: #f1f5f7;
  cursor: pointer;
  transition: border-color 0.25s;
}

button:hover {
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.3);
}

button:focus,
button:focus-visible {
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.3);
}

@media (prefers-color-scheme: light) {
  :root {
    background-color: #ffffff;
  }

  button {
    background-color: #f1f5f7;
  }
}

.item-error-tips {
  color: red;
  margin-top: 15px;
  white-space: normal;
  word-break: break-all;
}
</style>
